// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-area {
  background: rgba(208, 208, 228, 0.4039215686);
  color: #111;
  padding: 40px 0 30px;
  margin-top: 26px;
}
.footer-area .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}
.footer-area {
  /***********************
   * FOOTER TOP LOGO ROW
   ***********************/
}
.footer-area .footer-top-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 100px;
  margin-bottom: 40px;
}
.footer-area .footer-top-row .footer-logo {
  max-width: 130px;
  height: auto;
  padding: 10px;
}
.footer-area .footer-top-row .footer-logo-side {
  max-width: 90px;
  height: auto;
  padding: 10px;
}
.footer-area {
  /*******************************
   * FOOTER MAIN ROW - 4 COLUMNS
   *******************************/
}
.footer-area .footer-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
  flex-wrap: nowrap; /* Keep all in 1 row */
}
.footer-area .footer-bottom-row .footer-col {
  width: 25%;
  padding: 8px; /* Reduced spacing */
  text-align: left;
}
.footer-area .footer-bottom-row .footer-col .footer-title {
  font-size: 17px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 18px;
}
.footer-area {
  /*******************************
   * FOOTER LINKS SECTION
   *******************************/
}
.footer-area .footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-area .footer-links li {
  margin-bottom: 6px;
}
.footer-area .footer-links li a {
  color: rgba(17, 17, 17, 0.9);
  text-decoration: none;
  font-size: 15px;
  transition: 0.2s ease;
}
.footer-area .footer-links li a:hover {
  color: #b60a35;
  transform: translateX(4px);
}
.footer-area {
  /*******************************
   * CONTACT
   *******************************/
}
.footer-area .contact-info .contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}
.footer-area .contact-info .contact-item i {
  color: #b60a35;
  font-size: 18px;
}
.footer-area .contact-info .contact-item a {
  color: #111;
}
.footer-area .contact-info .contact-item a:hover {
  color: #b60a35;
}
.footer-area {
  /*******************************
   * SOCIAL ICONS
   *******************************/
}
.footer-area .footer-social {
  display: flex;
  gap: 10px;
  padding: 0;
  margin: 0;
  list-style: none;
}
.footer-area .footer-social li a {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(182, 10, 53, 0.1);
  color: #b60a35;
  transition: 0.3s ease;
}
.footer-area .footer-social li a:hover {
  background: #b60a35;
  color: white;
  transform: translateY(-2px);
}
.footer-area {
  /*******************************
   * COPYRIGHT
   *******************************/
}
.footer-area .footer-bottom {
  text-align: center;
  margin-top: 25px;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.footer-area .footer-bottom p {
  margin: 0;
  font-size: 14px;
  color: rgba(17, 17, 17, 0.6);
}

/********************************************
 * RESPONSIVE FIXES
 ********************************************/
@media (max-width: 991px) {
  .footer-area .footer-bottom-row {
    flex-wrap: wrap;
    text-align: center;
  }
  .footer-area .footer-bottom-row .footer-col {
    width: 50%; /* 2 per row */
  }
  .footer-area .footer-top-row {
    flex-wrap: wrap;
    text-align: center;
  }
}
@media (max-width: 600px) {
  .footer-area {
    padding: 30px 0;
  }
  .footer-area .footer-bottom-row .footer-col {
    width: 100%; /* 1 per row */
  }
  .footer-area .footer-title {
    font-size: 15px;
  }
  .footer-area .footer-social li a {
    width: 34px;
    height: 34px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.scss"],"names":[],"mappings":"AAKA;EACE,6CALU;EAMV,WALY;EAMZ,oBAAA;EACA,gBAAA;AAJF;AAME;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAJJ;AALA;EAYE;;0BAAA;AAFF;AAKE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;AAHJ;AAKI;EACE,gBAAA;EACA,YAAA;EACA,aAAA;AAHN;AAMI;EACE,eAAA;EACA,YAAA;EACA,aAAA;AAJN;AA3BA;EAmCE;;kCAAA;AAHF;AAME;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA,EAAA,sBAAA;AAJJ;AAMI;EACE,UAAA;EACA,YAAA,EAAA,oBAAA;EACA,gBAAA;AAJN;AAMM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAJR;AAlDA;EA2DE;;kCAAA;AAJF;AAOE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AALJ;AAOI;EACE,kBAAA;AALN;AAOM;EACE,4BAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AALR;AAOQ;EACE,cAlFM;EAmFN,0BAAA;AALV;AAzEA;EAoFE;;kCAAA;AANF;AAUI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AARN;AAUM;EACE,cArGQ;EAsGR,eAAA;AARR;AAWM;EACE,WAxGM;AA+Fd;AAWQ;EACE,cA7GM;AAoGhB;AA/FA;EA8GE;;kCAAA;AAVF;AAaE;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAXJ;AAaI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kCAAA;EACA,cArIU;EAsIV,qBAAA;AAXN;AAaM;EACE,mBAzIQ;EA0IR,YAAA;EACA,2BAAA;AAXR;AA3HA;EA2IE;;kCAAA;AAXF;AAcE;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AAZJ;AAcI;EACE,SAAA;EACA,eAAA;EACA,4BAAA;AAZN;;AAiBA;;6CAAA;AAIA;EAGI;IACE,eAAA;IACA,kBAAA;EAjBJ;EAmBI;IACE,UAAA,EAAA,cAAA;EAjBN;EAqBE;IACE,eAAA;IACA,kBAAA;EAnBJ;AACF;AAuBA;EACE;IACE,eAAA;EArBF;EAwBI;IACE,WAAA,EAAA,cAAA;EAtBN;EA0BE;IACE,eAAA;EAxBJ;EA2BE;IACE,WAAA;IACA,YAAA;EAzBJ;AACF","sourcesContent":["$primary-color: #b60a35;\n$footer-bg: #d0d0e467;\n$footer-text: #111;\n$footer-title: #111;\n\n.footer-area {\n  background: $footer-bg;\n  color: $footer-text;\n  padding: 40px 0 30px;\n  margin-top: 26px;\n\n  .container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 15px;\n  }\n\n  /***********************\n   * FOOTER TOP LOGO ROW\n   ***********************/\n  .footer-top-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 100px;\n    margin-bottom: 40px;\n\n    .footer-logo {\n      max-width: 130px;\n      height: auto;\n      padding: 10px;\n    }\n\n    .footer-logo-side {\n      max-width: 90px;\n      height: auto;\n      padding: 10px;\n    }\n  }\n\n  /*******************************\n   * FOOTER MAIN ROW - 4 COLUMNS\n   *******************************/\n  .footer-bottom-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 15px;\n    flex-wrap: nowrap;    /* Keep all in 1 row */\n\n    .footer-col {\n      width: 25%;\n      padding: 8px;       /* Reduced spacing */\n      text-align: left;\n\n      .footer-title {\n        font-size: 17px;\n        font-weight: 700;\n        text-transform: uppercase;\n        margin-bottom: 18px;\n      }\n    }\n  }\n\n  /*******************************\n   * FOOTER LINKS SECTION\n   *******************************/\n  .footer-links {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n      margin-bottom: 6px;\n\n      a {\n        color: rgba(17,17,17,0.9);\n        text-decoration: none;\n        font-size: 15px;\n        transition: 0.2s ease;\n\n        &:hover {\n          color: $primary-color;\n          transform: translateX(4px);\n        }\n      }\n    }\n  }\n\n  /*******************************\n   * CONTACT\n   *******************************/\n  .contact-info {\n    .contact-item {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-bottom: 10px;\n      font-size: 14px;\n\n      i {\n        color: $primary-color;\n        font-size: 18px;\n      }\n\n      a {\n        color: $footer-text;\n\n        &:hover {\n          color: $primary-color;\n        }\n      }\n    }\n  }\n\n  /*******************************\n   * SOCIAL ICONS\n   *******************************/\n  .footer-social {\n    display: flex;\n    gap: 10px;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n\n    li a {\n      width: 38px;\n      height: 38px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      background: rgba($primary-color, 0.1);\n      color: $primary-color;\n      transition: 0.3s ease;\n\n      &:hover {\n        background: $primary-color;\n        color: white;\n        transform: translateY(-2px);\n      }\n    }\n  }\n\n  /*******************************\n   * COPYRIGHT\n   *******************************/\n  .footer-bottom {\n    text-align: center;\n    margin-top: 25px;\n    padding-top: 10px;\n    border-top: 1px solid rgba(0,0,0,0.08);\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      color: rgba(17,17,17,0.6);\n    }\n  }\n}\n\n/********************************************\n * RESPONSIVE FIXES\n ********************************************/\n\n@media (max-width: 991px) {\n  .footer-area {\n\n    .footer-bottom-row {\n      flex-wrap: wrap;\n      text-align: center;\n\n      .footer-col {\n        width: 50%;   /* 2 per row */\n      }\n    }\n\n    .footer-top-row {\n      flex-wrap: wrap;\n      text-align: center;\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .footer-area {\n    padding: 30px 0;\n\n    .footer-bottom-row {\n      .footer-col {\n        width: 100%;   /* 1 per row */\n      }\n    }\n\n    .footer-title {\n      font-size: 15px;\n    }\n\n    .footer-social li a {\n      width: 34px;\n      height: 34px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
